import { useState } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { LayoutMountedContext } from '../../components/locasmart-layout';
import { FalhaContratoOnboarding, OnboardingContext } from './OnboardingContext';
import { rastrearTeste } from '../../services/rastreamentoTeste';
import { AreaLocacao, Botao, CartaoAviso, FundoAviso } from './styles';
import LocacaoListagem from '../movimentacoes/locacao';

interface Props {
    idModeloContrato?: string;
    semVeiculoLivre?: boolean;
    aoCriarLocacao: (idLocacao: string) => void;
    registrarLocacaoCriada: (idLocacao: string) => void;
}

// A primeira locação é feita na tela de Locação do próprio sistema, com o passo a passo por cima:
// o locador aprende ali mesmo a tela que vai usar todo dia.
export default function EtapaLocacao({ idModeloContrato, semVeiculoLivre, aoCriarLocacao, registrarLocacaoCriada }: Props) {
    const [falha, setFalha] = useState<FalhaContratoOnboarding | null>(null);

    const criarSemContrato = () => {
        const tentativa = falha;
        rastrearTeste('onboarding_locacao_sem_contrato');
        setFalha(null);
        tentativa?.criarSemContrato();
    };

    return (
        <>
            <AreaLocacao>
                <LayoutMountedContext.Provider value={true}>
                    <OnboardingContext.Provider value={{ ativo: true, aoCriarLocacao, registrarLocacaoCriada, aoFalharContrato: setFalha, idModeloContrato, semVeiculoLivre }}>
                        <LocacaoListagem />
                    </OnboardingContext.Provider>
                </LayoutMountedContext.Provider>
            </AreaLocacao>

            {falha && (
                <FundoAviso role="dialog" aria-modal="true" aria-labelledby="titulo-falha-contrato">
                    <CartaoAviso>
                        <h2 id="titulo-falha-contrato">Não conseguimos gerar o contrato</h2>
                        <p>A locação não foi criada porque o seu contrato não pôde ser preenchido agora.</p>
                        {falha.motivo && <p><strong>{falha.motivo}</strong></p>}
                        <p>Você pode criar a locação sem o contrato e seguir. Depois, é só gerar o contrato pela tela de Locação, no menu da locação.</p>
                        <div className="acoes">
                            <Botao type="button" $variante="secundario" onClick={() => setFalha(null)}>Voltar ao formulário</Botao>
                            <Botao type="button" onClick={criarSemContrato}>Criar a locação sem o contrato <FaArrowRight /></Botao>
                        </div>
                    </CartaoAviso>
                </FundoAviso>
            )}
        </>
    );
}
